import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { NotFound } from '@freelancer/404';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const UserAvailabilityGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const featureFlagsService = inject(FeatureFlagsService);
  const notFound = inject(NotFound);

  return featureFlagsService
    .getFlag(Feature.USER_AVAILABILITY)
    .pipe(
      switchMap(isUserAvailabilityEnabled =>
        isUserAvailabilityEnabled ? of(true) : notFound.render(),
      ),
    );
};
